'use client';

import { useTranslations } from 'next-intl';
import * as styles from './unitsModule.styles';

type FloorPlanDotsProps = {
  count: number;
  current: number;
  onSelect: (index: number) => void;
};

export const FloorPlanDots = ({ count, current, onSelect }: FloorPlanDotsProps) => {
  const t = useTranslations('hdp');

  if (count <= 1) return null;

  return (
    <div className={styles.floorPlanDots}>
      {Array.from({ length: count }, (_, index) => (
        <button
          key={index}
          type="button"
          className={styles.floorPlanDot}
          onClick={() => onSelect(index)}
          aria-label={t('goToFloorPlan', { number: index + 1 })}
          aria-current={index === current ? 'true' : undefined}
        />
      ))}
    </div>
  );
};
